import React from 'react'
import NewProject from '../Components/ProjectSec/NewProject'
import Sidebar from '../Components/Sidebar'

const CreateProjectPage = () => {
  return (
    <div >
   
        <NewProject/>
    </div>
  )
}

export default CreateProjectPage